import { GenerateTripAccommodations } from 'app/constants/configuration/generateTripAccommodations'

export const getGenerateTripAccommodationsName = (
  generateTripAccommodations: GenerateTripAccommodations,
  translate: (string) => string,
): string => {
  const text: string = GenerateTripAccommodations[generateTripAccommodations]
  return translate(`generateTripAccommodations.${text}`)
}
